import React, { useCallback } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { IssueLinkTypeSelect } from '../../common/ui/issue-link-type-select';
import { useAvailableIssueLinkTypes, useDraft, useFormState } from '../../controllers';
import { DependencyListItem } from './dependency-list-item';
import { messages } from './messages';

export const DependencyList = () => {
	const { formatMessage } = useIntl();
	const [dependencies, { add }] = useDraft();
	const [{ savingInProgress }] = useFormState();
	const [availableIssueLinkTypes] = useAvailableIssueLinkTypes();

	const handleRequestAdd = useCallback(
		(id: number | undefined) => {
			if (id) add(id, 'OUTWARD');
		},
		[add],
	);
	return (
		<Box xcss={containerStyles}>
			<Box xcss={containerStyles} role="list">
				{dependencies.map((dependency) => (
					<DependencyListItem key={dependency.issueLinkTypeId} dependency={dependency} />
				))}
			</Box>
			<IssueLinkTypeSelect
				placeholder={formatMessage(messages.addLinkType)}
				options={availableIssueLinkTypes}
				onChange={handleRequestAdd}
				disabled={savingInProgress}
				aria-label={formatMessage(messages.addLinkType)}
			/>
		</Box>
	);
};

const containerStyles = xcss({
	display: 'flex',
	flexDirection: 'column',
	gap: 'space.100',
});
